export default __webpack_public_path__ + "static/color-tokens-in-screen-light-32b77417840c72ec49d4bf28fcbbd95f7a30b7e50dcf4ff9d6a39f1d21d1a017.png";